<template>
	<AppFilter @apply="onFilter" v-model="filters" :isPadding="true" ref="appFilter"/>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		name:"issueAdvanceFilter",
		props: {

		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {
			selectedPartner: {
				async handler() {
					this.productAdvanceFilter = []
					this.setFilters()
				}
			},
			isSeller: {
				async handler(){
					this.filterOptions = await this.$store.dispatch("productAlerts/getFilters")
				}
			}
		},
		computed: {
			productAdvanceFilter:{
				set(val){
					this.$store.commit('productAlerts/setadvanceFilterProduct',val)
				},
				get(){
					return this.$store.state.productAlerts.productAdvanceFilter
				}
			},
			selectedPartner:{
				set(val){
				},
				get(){
					return this.$store.state.selectedVendorPartnerUuid
				}
			},
			isSeller:{
				set(val){
					this.$store.state.isSeller = val
				},
				get(){
					return this.$store.state.isSeller
				}
			}
		},
		async mounted() {
			this.filterOptions = await this.$store.dispatch("productAlerts/getFilters")

			this.asinFilter = this.filterOptions.all_asins || []
			this.skuFilter = this.filterOptions.all_skus || []
			this.vendorCodeFilter = this.filterOptions.all_vendor_codes || []
			this.upcFilter = this.filterOptions.all_upcs || []
			this.workStatusFilter = this.filterOptions.work_status || []

			this.$store.state.productAlerts.filterOptions = this.filterOptions
			
			this.setFilters()

		},
		methods: {
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
					filters[input[i].name] = input[i].value;
				}

				filters.advanceSearchType = "product";
				let payload = {};

				console.log('FILTERS: ', filters)

				if(filters["asin"]){
					payload.asin = filters['asin'].value
				}

				if(filters["sku"]){
					payload.sku = filters['sku'].value
				}

				if(filters["vendor_code"]){
					payload.vendor_code = filters['vendor_code'].value
				}
				
				if(filters["work_status"]){
					payload.work_status = filters['work_status'].value
				}

				if(filters["last_updated"]){
					payload.last_updated = filters['last_updated'].value
				}

				if(filters["upc"]){
					payload.upc = filters['upc'].value
				}

				if(filters["show_worked"]){
					payload.showWorked = filters['show_worked'].value
				}

				if(filters["issue_category"]){
					payload.issue_category = filters['issue_category'].value
				}

				if(filters["amz_enforcement"]){
					payload.enforcement = filters['amz_enforcement'].value
				}
				
				console.log('FILTERING')
				this.$store.state.currentPageNumber = 1;
				// this.$store.commit("productAlerts/setadvanceFilterProduct", payload);
				this.$store.commit("productAlerts/setIssueFilters", payload)
				this.$emit("getFilterProducts", payload);
				// await this.getData()
				this.setFilters()
			},
			setFilters() {
				// this.filters = [];

				if (this.productAdvanceFilter.length > 0) {
					this.filters = this.productAdvanceFilter
					return 
				}
				this.filters = [	
					{
						name: "break",
						type: "break"
					},
					{
						name: "issue_category",
						label: "Issue Category",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: [
							{name: 'No issues found', value: 'No issues found'}, 
							{name: 'Image', value: 'Image'},
							{name: 'Attribute', value: 'Attribute'},
							{name: 'Price', value: 'Price'},
							{name: 'Duplicate', value: 'Duplicate'},
							{name: 'Qualification', value: 'Qualification'},
						],
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "amz_enforcement",
						label: "AMZ Enforcement",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: [
							{name: 'Attribute Suppressed', value: 'ATTRIBUTE_SUPPRESSED'},
							{name: 'Search Suppressed', value: 'SEARCH_SUPPRESSED'},
							{name: 'Listing Suppressed', value: 'LISTING_SUPPRESSED'},
							{name: 'Catalog Item Removed', value: 'CATALOG_ITEM_REMOVED'},
							{name: 'Any', value: 'ANY'},
							{name: 'None', value: 'NONE'},
						],
						padding:true
					},
					{
						name: "break",
						type: "break"
					},

					{
						name: "work_status",
						label: "Work Status",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.workStatusFilter.sort().map(t => ({name: t, value: t})),
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "last_updated",
						label: "Last Updated",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: [
							{name: 'Less Than 2 Weeks', value: '2minus'},
							{name: 'Between 2-4 Weeks', value: '2to4'},
							{name: 'More Than 4 Weeks', value: '4plus'},
						],						
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "vendor_code",
						label: "Vendor Code",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.vendorCodeFilter.sort().map(t => ({name: t, value: t})),
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
				];
				this.productAdvanceFilter = JSON.parse(JSON.stringify(this.filters))
			}

		},
		data() {
			return {
				filters: [],
				filterOptions: [],
				vendorCodeFilter: [],
				upcFilter: [],
				asinFilter: [],
				skuFilter:[],
				workStatusFilter:[],
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
